import { API_BASE_URL, API_UPDATE_APP_USER } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export type ResultDetail = {
    [key: string]: boolean[]; // Keys like "hard-heard", "cat-cut", etc., and their boolean arrays
};

export type appUserInfo = {
    currentEmail: string,
    newEmail: string | null,
    studentName: string | null,
    classRoomName: string | null,
    password: string | null,
    role: string | null
};

export type getCreateAppUserReponse = {
    status: string,
    message: string
};


async function executeGetUpdateAppUserWithToken(accessToken: string | null, appUserInfo: appUserInfo): Promise<getCreateAppUserReponse> {
    return axios
        .post(
            API_BASE_URL + API_UPDATE_APP_USER,
            {
                currentEmail: appUserInfo.currentEmail,
                newEmail: appUserInfo.newEmail,
                studentName: appUserInfo.studentName,
                classRoomName: appUserInfo.classRoomName,
                password: appUserInfo.password,
                role: appUserInfo.role
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            throw new Error("Unexpected response status or missing data");
        })
        .catch(error => {
            if (error.response && error.response.status === 400) {
                console.log("Missing required fields");
            } else if (error.response && error.response.status === 403) {
                console.log("Missing required role");
            } else if (error.response && error.response.status === 404) {
                console.log("Param(s) not exist.");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetUpdateAppUserWithToken(accessToken: string | null, uuids: appUserInfo): Promise<getCreateAppUserReponse> {

    return executeGetUpdateAppUserWithToken(accessToken, uuids)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetUpdateAppUserWithToken(accessToken, uuids);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
